import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import baseUrl from "../../../api/baseUrl";
import BottomTab from "../../../components/pagination/BottomTab";
import CommonLayout from "../../../layouts/commonLayout/CommonLayout";
import Container from "../../../layouts/containers/Container";

function ClinicData() {
  const [data, setdata] = useState([]);
  const [count, setcount] = useState(0);
  const [days, setDays] = useState(7);
  const [page, setpage] = useState(1);
  const navigate = useNavigate();
  const getdata = (pages: any, days: number) => {
    baseUrl
      .get("/admin/dashboad/findClinicData", {
        headers: {
          page: pages,
          days: days,
        },
      })
      .then((response) => {
        setdata(response.data.data);
        setcount(response.data.count);
      })
      .catch((error) => {
        console.error(error.response);
      });
  };
  useEffect(() => {
    getdata(page,days);
  }, []);

  const onPageChange = (e: any) => {
    getdata(e,days);
    setpage(e);
  };
  const onSelect = (e: any) => {
    setDays(e)
    getdata(page,e);
    setpage(page);
  };
  return (
    <CommonLayout>
      <Container>
        <div className={"view_clinic"}>
          {/* <div className="addClinicbtn">
      <button>Add Clinic</button>
    </div> */}
          <div className={"head"}>
            <p className={"headTxt"}>Clinic List</p>
            <div className={"table_heading"}>
              <select
                value={days}
                onChange={(e) => onSelect(Number(e.target.value))}
              >
                <option value={1}>today</option>
                <option value={7}>last 7 days</option>
                <option value={30}>last 30 days</option>
              </select>
            </div>
          </div>

          <div className={"table_view_patient"}>
            <table>
              <thead>
                <tr className={"tr"}>
                  <th className={"th"}>Clinic Name</th>
                  <th className={"th"}>No Of Patients</th>
                  <th className={"th"}>No Of treatments</th>
                  <th className={"th"}>No Of appointment</th>
                  <th className={"th"}>No Of staffs</th>
                  <th className={"th"}>total amount</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item: any, i: number) => {
                  return (
                    <tr key={i} className={"tr"}>
                      <td data-label="Clinic Id" className={"tdmain"}>
                        {item?.clinicName}
                      </td>
                      <td data-label="Reg No" className={"tdmain"}>
                        {item?.patients}
                      </td>
                      <td data-label="Clinic Name" className={"tdmain"}>
                        {item?.treatments}
                      </td>
                      <td data-label="Address" className={"tdmain"}>
                        {item?.appointment}
                      </td>
                      <td data-label="Clinic Name" className={"tdmain"}>
                        {item?.staffs}
                      </td>
                      <td data-label="Address" className={"tdmain"}>
                        {item?.total}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <BottomTab
            title={"Clinics"}
            count={count}
            onPageChange={onPageChange}
          />
        </div>
      </Container>
    </CommonLayout>
  );
}

export default ClinicData;
